/* eslint-disable camelcase */
export enum PricingKind {
  BASIC = "BASIC",
  STANDARD = "STANDARD",
  PREMIUM = "PREMIUM",
}

export enum Currency {
  TWD = "TWD",
  USD = "USD",
  JPY = "JPY",
}

export enum OrderState {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PAID = "PAID",
  FAILED = "FAILED",
}

export interface PurchasePlan {
  id: string;
  kind: PricingKind;
  currency: Currency;
  amount: number;
  offered_second: number;
  promotion_expired_at: number;
  duration: number;
  purchasable: boolean;
}

export interface Order {
  state: OrderState;
  error?: string;
  error_code?: string;
}

export interface BusinessInfo {
  organization: string;
  account: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  company_name?: string;
  tax_id?: string;
}
